<template>
  <!-- 登录页 -->
  <div class="login">
    <div class="logo"><img src="../../assets/login/logo.png" alt="" /></div>
    <div class="content">
      <!-- 左侧 -->
      <div class="left">
        <img src="../../assets/login/left.png" alt="" />
      </div>
      <!-- 右侧登录 -->
      <div class="rightBox">
        <div class="text">登录到</div>
        <div class="text">LERITEC</div>
        <el-form
          :model="loginForm"
          :rules="loginRules"
          ref="loginForm"
          :show-message="false"
        >
          <el-form-item prop="account">
            <!--   prefix-icon="el-icon-user" -->
            <el-input v-model="loginForm.account" placeholder="请输入账号">
              <p slot="prefix" class="iptImg">
                <img src="@/assets/login/user.png" alt="" />
              </p>
            </el-input>
          </el-form-item>
          <el-form-item prop="passwords">
            <!--  prefix-icon="el-icon-unlock" -->
            <el-input
              v-model="loginForm.passwords"
              placeholder="请输入密码"
              show-password
            >
              <p slot="prefix" class="iptImg">
                <img src="@/assets/login/password.png" alt="" />
              </p>
            </el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-checkbox v-model="loginForm.checked">记住密码</el-checkbox>
          </el-form-item>-->
          <el-form-item>
            <el-button
              type="primary"
              @click="submitForm('loginForm')"
              :loading="loginLoading"
              class="blue-btn"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// 引入md5加密
// import md5 from "js-md5";
export default {
  data() {
    return {
      loginLoading: false,
      loginForm: {
        account: "",
        passwords: "",
        checked: false,
      },
      loginRules: {
        phone: [
          {
            required: true,
            validator: this.validator.phone,
            trigger: "blur",
          },
        ],
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        passwords: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 登录
    submitForm(formName) {
      this.$refs[formName].validate((valid, values) => {
        if (valid) {
          this.loginLoading = true;
          // this.loginForm.password = md5(this.loginForm.passwords);
          this.loginForm.password = this.loginForm.passwords;
          this.$store
            .dispatch("enterLogin", this.loginForm)
            .then(() => {
              this.$router.push({ path: this.redirect || "/" }).catch(() => {});
              this.loginLoading = false;
            })
            .catch(() => {
              this.loginLoading = false;
            });
        } else {
          // console.log(valid, values);
          // console.log(
          //   "Object.values(values) :>> ",
          //   Object.values(values)[0][0].message
          // );
          this.$message.info(Object.values(values)[0][0].message);
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  background: url("../../assets/login/bg.png") no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  .logo {
    padding: 42px 0 0 45px;
    img {
      width: 113px;
      height: 27px;
    }
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 92px;
    .left {
      margin-left: -100px;
      img {
        width: 698px;
        height: 699px;
      }
    }
    .rightBox {
      // margin-left: 260px;
      // padding-top: 105px;
      // padding: ;
      padding-right: 214px;
      .text {
        font-weight: 600;
        font-size: 36px;
        color: #000000;
        line-height: 50px;
      }
      ::v-deep .el-form {
        margin-top: 46px;
        .el-form-item {
          width: 328px;
          margin-bottom: 24px;
          .el-form-item__content {
            line-height: 1;
          }
          .el-input {
            border: none;
            .el-input__inner {
              height: 40px;
              line-height: 40px;
              border-radius: 8px;
              padding: 8px 16px 8px 36px;
              color: #333333;
              font-size: 16px;
            }
            .el-input__inner:focus {
              border-color: none;
            }
            .el-input__prefix {
              top: 50%;
              margin-top: -8px;
              left: 12px;
              .iptImg {
                width: 16px;
                height: 16px;
                img {
                  width: 100%;
                }
              }
            }
          }
          input::-webkit-input-placeholder {
            /* WebKit browsers */
            color: #cccccc;
          }
          .el-button {
            width: 100%;
            padding: 9px 0;
            color: #ffffff;
            border-radius: 8px;
            line-height: 1;
            margin-top: 30px;
            letter-spacing: 4px;
            background: #ff5d2f;
            span {
              font-weight: 500;
              font-size: 16px;
              color: #ffffff;
              line-height: 22px;
            }
            .el-icon-loading {
              font-size: 22px;
            }
          }
          .el-button:hover {
            background: #ff5d2f;
          }
        }
        .is-error {
          .el-input__inner {
            border-color: #dcdfe6;
          }
        }
        .el-form-item:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
